import { Skeleton } from "@/components/ui/skeleton";

function SessionGroupSkeleton() {
  return (
    <div className="relative scroll-mt-4 space-y-4">
      <div>
        <div className="absolute -left-6 top-1 inline-block rounded-full border border-secondary bg-white p-0.5 ring-8 ring-white dark:bg-background dark:ring-background">
          <div className="size-2 rounded-full bg-secondary"></div>
        </div>
        <Skeleton className="h-5 w-20" />
        <Skeleton className="mt-1 h-4 w-32" />
      </div>
      {[1, 2].map((index) => (
        <div key={index} className="rounded-md border border-border bg-card">
          <div className="space-y-4 p-4">
            <div className="space-y-4 border-l-2 border-primary pl-4">
              <Skeleton className="h-6 w-3/4" />
              <div className="flex gap-4">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-4 w-24" />
              </div>
              <div className="flex items-center gap-2">
                <Skeleton className="size-10 rounded-full" />
                <div className="space-y-1">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-3 w-16" />
                </div>
              </div>
            </div>
            <div className="flex justify-end gap-2">
              <Skeleton className="h-9 w-20" />
              <Skeleton className="h-9 w-24 bg-[#6941C6]" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export function SessionListSkeleton() {
  return (
    <div className="space-y-8 border-l-2 border-border pl-4">
      <SessionGroupSkeleton />
      <SessionGroupSkeleton />
    </div>
  );
}
